export default function($) {

  $('.js-product-card').each(function() {

    $(this).find('.js-product-card-variation').on('click', function(e) {
      e.preventDefault();
      var srcset = $(this).find('img').data('srcset'),
          toShow = $(this).parents('.js-product-card').find('.js-product-card-picture');

      toShow.attr('srcset', srcset);
    })
  });
}
